import React from 'react';
import 'moment/locale/pt-br';
import * as XLSX from 'xlsx';
import { secondary } from 'styles/colorProvider';

const ExportToExcel = ({ exportData, fileName }) => {
  const fileExtension = '.xlsx';

  const exportToXLSX = (exportData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, fileName + fileExtension);
  };

  return (
    <button
      style={{
        height: 30,
        width: '100%',
        margin: 0,
        cursor: 'pointer',
        borderRadius: 20,
        border: 'none',
        backgroundColor: secondary,
      }}
      onClick={(e) => exportToXLSX(exportData, fileName)}
    >
      Baixar
    </button>
  );
};

export default ExportToExcel;
